// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const SELECT_RATING = "Vyber hodnotenie";
export const TOOLBAR_REPLYING_TO = "Odpoved\u00e1\u0161 na:";
